function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-8014.18 -4058.18)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 1015.22,
  cy: 1033.6,
  r: 843.751,
  fill: "#fff",
  transform: "translate(8072.18 4066.09)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8544 5677c-245-187-301-533-237-793 185-498 623-695 1160-501 302 168 456 390 444 741-22 167-69 320-199 459 0-103 67-250 79-358 0-106-19-85 61-142 3-4-198-376-206-388-290-184-291 110-296 313-19 29-51 25-79 26-61-45-28-107-22-161h-47c-3-75-34-272-12-329-37-12-50-19-45-43 37-12 37-12 69-14-2-10-3-20-3-29-81-14-148-49-210-38-2 4-3 9-3 14 6 4 12 9 19 14 22-9 22-9 58-9 9 9 23 42 26 67-72 0-134-29-187-23-2 7-3 14-3 23 182 90 117 230 47 400-17 20-41 32-34 62 14 0 28 1 42 3 6 75-139 155-139 7 50-194 65-430-204-297-34 36-257 362-257 423 16 14 61 3 79 39 8 222 8 222 19 294 0 3 97 249 81 239l-1 1zm727-58c-117-6-229-14-338-12 12-116 210-256 210-358-93-68-176 30-241 55-76-39-125-62-187-12 58 81 220 104 153 256-67 43-252 32-322 29 0-30 11-48 22-68 56 0 139 32 199 12 0-9 2-17 3-26-73-83-135-122-135-213 45-126 145-61 252-51 20-29 20-29 67-68 132 14 240 23 385 13-44 103-252 297-252 376 132 81 184-39 257-80 50 17 89 35 156 43 100-93-333-253-40-343 92 6 135 17 243 13-16 32-31 64-47 96-61 0-125-61-165-4 45 77 227 103 121 261-145 83-259-87-307 72-17 7-17 7-33 7l-1 2z",
  fill: "#fe0000",
  stroke: "#e31e24",
  strokeWidth: 7.62
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 9094,
  cy: 5101,
  rx: 858,
  ry: 821,
  fill: "none",
  stroke: "#ffed00",
  strokeWidth: 107.6
}));

function SvgLogoSzsinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2160 2086",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _ref);
}

export default SvgLogoSzsinline;